import { useContext, useState } from "react";
import SelectedFileHeader from "./SelectedFileHeader";
import ThemeContext from "../../../context/theme/ThemeContext";
import { useTranslation } from "react-i18next";
import moment from "moment";
import { getFileDescriptionFromKey, getFileNameFromKey } from "./helpers";

const SelectedFile = ({ file, onBackClick, isDrawerExpanded }) => {
	const { withTheme } = useContext(ThemeContext);
	const { t } = useTranslation();
	const [isDeleteLoading, setIsDeleteLoading] = useState(false);

	const handleDeleteClick = async () => {
		setIsDeleteLoading(true);

		// TODO: Handle

		setIsDeleteLoading(false);
	};

	return (
		<div
			style={{
				transition: "0.3s",
				width: `calc(100% - ${isDrawerExpanded ? 320 : 64}px)`,
				paddingLeft: 40,
				paddingRight: 40,
				borderTopRightRadius: 6,
				borderBottomRightRadius: 6,
				overflowY: "auto",
			}}
		>
			{!file ? (
				<div
					style={{ paddingTop: 92, textAlign: "center" }}
					className={withTheme("empty-page-text")}
				>
					{t("fileNotSelectedMessage")}
				</div>
			) : (
				<>
					<SelectedFileHeader
						file={file}
						onBackClick={onBackClick}
						isDeleteLoading={isDeleteLoading}
						onDeleteClick={handleDeleteClick}
					/>

					<div className={withTheme("search-page-item-title")} style={{ fontSize: 20 }}>
						{getFileNameFromKey(file.Key)}
					</div>

					<div style={{ marginTop: 24 }} className={withTheme("item-element-container")}>
						<div className={withTheme("item-element-name")}>{t("added")}</div>
						<div className={withTheme("item-element-value")}>
							{moment(file.LastModified).format("DD MMM YYYY")}
						</div>
					</div>

					<div style={{ marginTop: 24 }} className={withTheme("item-element-container")}>
						<div className={withTheme("item-element-name")}>{t("description")}</div>
						<div className={withTheme("item-element-value")}>
							{getFileDescriptionFromKey(file.Key)}
						</div>
					</div>
				</>
			)}
		</div>
	);
};

export default SelectedFile;
